module.exports = __webpack_public_path__ + "static/what-a6b050f46c6b36fd26c6181d1b746e33.gif";